export const DefaultOrderTypeBased = [
  {
    id: 'takeaway',
    label: 'Takeaway',
    value: 0,
  },
  {
    id: 'delivery',
    label: 'Delivery',
    value: 0,
  },
  {
    id: 'dineIn',
    label: 'Dine In',
    value: 0,
  },
  {
    id: 'room',
    label: 'Room',
    value: 0,
  },
];
export const DefaultPaymentMethodBased = [
  {
    id: 'qris',
    label: 'QRIS',
    value: 0,
  },
  {
    id: 'debit_card',
    label: 'DEBITCARD',
    value: 0,
  },
  {
    id: 'credit_card',
    label: 'CREDITCARD',
    value: 0,
  },
];
export const DefaultOthersBased = [
  // {
  //   id: 'rewards',
  //   label: 'Rewards Service Fee',
  //   value: 0,
  //   type: 'percent',
  //   isFee: true,
  // },
  // {
  //   id: 'repeated_users',
  //   label: 'Repeat User Fee',
  //   value: 0,
  //   type: 'percent',
  //   isFee: true,
  // },
  // {
  //   id: 'new_users',
  //   label: 'New User Fee',
  //   value: 0,
  //   type: 'percent',
  //   isFee: true,
  // },
  {
    id: 'data_automation',
    label: 'Data Automation Fee',
    value: 0,
    type: 'percent',
    isFee: true,
  },
  {
    id: 'include_no_phone_input_sales',
    label: 'Include No Phone Input Sales',
    value: false,
    type: 'checkbox',
  },
  {
    id: 'repeat_sales',
    label: 'Repeat Sales Fee',
    value: 0,
    type: 'percent',
    isFee: true,
  },
  {
    id: 'referral_sales',
    label: 'Referral Sales Fee',
    value: 0,
    type: 'percent',
    isFee: true,
  },
  {
    id: 'new_traffic_sales',
    label: 'New Traffic Sales Fee',
    value: 0,
    type: 'percent',
    isFee: true,
  },
  {
    id: 'message',
    label: 'Message Fee',
    value: 0,
    type: 'price',
    isFee: true,
  },
];
export const DefaultMonthlyBased = [
  {
    id: 'subscription',
    label: 'Subscription Fee',
    value: 0,
    type: 'price',
    isFee: true,
  },
  {
    id: 'wa_monthly_subs',
    label: 'WA Monthly Subs Fee',
    value: 0,
    type: 'price',
    isFee: true,
  },
  {
    id: 'edc_rental',
    label: 'EDC Rental Fee',
    value: 0,
    type: 'price',
    isFee: true,
  },
  {
    id: 'min_edc_rental_fee',
    label: 'Minimum EDC Usage Amount to Waive EDC Rental Fee',
    value: 0,
    type: 'price',
    isSub: true,
  },
];
